<template>
  <button
    class="button-yellow space-top-1em"
    :disabled="isProcessing"
    title="Write a review"
    type="button"
    @click="writeReview"
  >
    <span v-if="isProcessing">
      <span class="valign-middle">Adding to library...</span>
      <DuiLoadingIndicator
        class="space-left-1em"
        size="sm"
        style="margin: -4px 0;"
      />
    </span>
    <span v-else>Write a review</span>
  </button>
</template>

<script>
import Vue from 'vue';

import bookshelfService from '@d-services/bookshelf-service/bookshelf-service';
import { getErrorMessage } from '@d-shared/utils/errors';
import { INITIAL_BOOKSHELF } from '@d-shared/config';
import URLS from '@d-shared/urls/urls';
import Window from '@d-shared/utils/window';

export default {
  props: {
    bookshelf: {
      type: String,
      default: null,
    },
    bookSlug: {
      type: String,
      required: true,
    },
    bookUrl: {
      type: String,
      required: true,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isProcessing: false,
  }),
  computed: {
    storeBookshelf() {
      return this.$store.getters['Book/get-bookshelf'];
    },
  },
  mounted() {
    this.setBookshelf();
  },
  methods: {
    async addToLibrary() {
      this.$set(this, 'isProcessing', true);

      try {
        const data = {
          bookshelf_entry: {
            bookshelf: INITIAL_BOOKSHELF,
            book_url: this.bookUrl,
            skip_post: true,
          },
        };

        await bookshelfService.addEntry(data);
        this.$store.dispatch('Book/setBookshelf', INITIAL_BOOKSHELF);
        this.goToBookshelf();
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    goToBookshelf() {
      Window.goTo(URLS.app.library.bookshelf);
    },

    setBookshelf() {
      if (!this.bookshelf) {
        return;
      }

      this.$store.dispatch('Book/setBookshelf', this.bookshelf);
    },

    writeReview() {
      if (!this.isUserSignedIn) {
        Vue.prototype.eventsTracking.continueChain('write-a-review', { bookSlug: this.bookSlug });
        Vue.prototype.signupModal.show();
        return;
      }

      if (this.isProcessing) {
        return;
      }

      if (!this.storeBookshelf) {
        this.addToLibrary();
        return;
      }

      this.goToBookshelf();
    },
  },
};
</script>
